import axios from 'axios';
import { Config } from '../config';
import { action, observable } from 'mobx';
import ReactHtmlParser from 'react-html-parser';

class FooterText {
    @observable footerData = {
      'colophon_text': '',
      'approval_code': '',
      'date_of_prep': '',
      'site_footer_text': ''
    }

    @action
    getFooterData = key => {
      const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.lynx}${Config.endpoint.wordpress.options}?option=${ key }`
      return axios.get( endpoint ).then(response => ReactHtmlParser(response.data))
    }

    @action
    populate = () => {
      Object.keys(this.footerData).map(key => {
        return this.getFooterData(key).then(response => {
          this.footerData[key] = response[0]
        })
      })
    }

}

const FooterTextStore = new FooterText()
export default FooterTextStore
